/**
 * 车辆年度油耗统计组件
 */

import { useEffect, useState } from 'react';
import { Row, Col, message, InputNumber } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

var date = new Date();
const CURRENTYEAR = date.getFullYear();

const CarCDCO = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);
    const [year, setYear] = useState(CURRENTYEAR);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'start_date': year + '-01-01',
                    'end_date': year + '-12-31',
                }
                $.ajax({
                    url: `${CNF.api}reports/car/cdco${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh, messageApi, year]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '车辆年度油耗统计',
            subtitle: '展示年度内车辆年度油耗统计金额。',
        });

        chart.data(data);

        chart
            .interval()
            .encode('x', 'type')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '年份', })
            .axis('y', {
                title: '金额',
                titleFill: '#5B8FF9',
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(CNF.DPL) + '万元' : d + '元'}`
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .tooltip({
                items: [
                    (d) => {
                        return { channel: 'y', value: `${d.count}个`, }
                    },
                ],
            })
            .style('minWidth', 40)
            .style('maxWidth', 60);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <>
        {contextHolder}
        <Row style={{ margin: '15px 0 0 15px' }}>
            <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                <InputNumber
                    placeholder='选择年份'
                    style={{ width: '100%' }}
                    min={2023}
                    max={2043}
                    suffix='年'
                    value={year ? year : null}
                    onChange={(value) => { setYear(value); setIsRefresh(true); }}
                />
            </Col>
        </Row>
        <div id='antv-g2-id'></div>
    </>

}

export default CarCDCO;